<template>
    <div class="chart-info">
        <div class="chart-info__left">
            <div class="chart-info__row">
                <div :class="fullStatus ? 'chart-info__title chart-info__title--full' :'chart-info__title'">БАЛАНС</div>
                <div :class="fullStatus ? 'chart-info__data chart-info__data--full' : 'chart-info__data'">
                    <watcher :data="balance"
						 :units="'$'"
						 :side="'left'"
                    >
                    </watcher>
                </div>
                    <!--<div class="chart__inf-wrap-item-data-green-pips">{{deltaBalance.toFixed(5)}}%</div>-->
                    <!--<div class="chart__inf-wrap-item-data-green-pips">1243 p</div>-->
            </div>
            <div class="chart-info__row">
                <div :class="fullStatus ? 'chart-info__title chart-info__title--full' :'chart-info__title'">СРЕДСТВА</div>
                <div :class="fullStatus ? 'chart-info__data chart-info__data--full' : 'chart-info__data'">
                    <watcher :data="equity"
						 :units="'$'"
						 :side="'left'"
                    >
                    </watcher>
                </div>
                <!--<div class="chart__inf-wrap-item-data-green-pips">{{deltaEquity}}%</div>
                <div class="chart__inf-wrap-item-data-green-pips">1243 p</div>-->
            </div>
            <div class="chart-info__row">
                <div :class="fullStatus ? 'chart-info__title chart-info__title--full' :'chart-info__title'">ЧИСТАЯ ПРИБЛЬ</div>
                <div :class="fullStatus ? 'chart-info__data chart-info__data--full' : 'chart-info__data'">
                    <watcher :data="profit"
							 :units="'$'"
							 :side="'left'"
                 	>
                    </watcher>
                </div>
            </div>
            <div class="chart-info__row">
                <div :class="fullStatus ? 'chart-info__title chart-info__title--full' :'chart-info__title'">ТЕКУЩИЙ ДОХОД</div>
                <div :class="fullStatus ? 'chart-info__data chart-info__data--full' : 'chart-info__data'">
                    <watcher :data="currencyProfit"
						 :units="'$'"
						 :side="'left'"
                    >
                    </watcher>
                </div>
            </div>
            <div class="chart-info__row">
                <div :class="fullStatus ? 'chart-info__title chart-info__title--full' :'chart-info__title'">КРЕДИТНОЕ ПЛЕЧО</div>
                <div :class="fullStatus ? 'chart-info__data chart-info__data--full' : 'chart-info__data'">
                    {{leverege}}</div>
            </div>
            <!--<div class="chart__inf-wrapper">
                <div :class="fullStatus ? 'chart__inf-item__title chart__inf-item__title-full' :'chart__inf-item__title'">ДОХОД %</div>
                <div :class="fullStatus ? 'chart__inf-item__data chart__inf-item__data-full' : 'chart__inf-item__data'">
                    <watcher :data="profitPercent" :units="'%'" :side="'left'"
                    :styleIconGreen = "styleIconGreenCurr"
                    :styleIconRed = "styleIconRedCurr">
                    </watcher>
                </div>
            </div>
            <div class="chart__inf-wrapper">
                <div :class="fullStatus ? 'chart__inf-item__title chart__inf-item__title-full' :'chart__inf-item__title'">ДОХОД PIP</div>
                <div :class="fullStatus ? 'chart__inf-item__data chart__inf-item__data-full' : 'chart__inf-item__data'">
                    <watcher :data="profitPips" :units="'q'" :side="'left'"
                    :styleIconGreen = "styleIconGreenCurr"
                    :styleIconRed = "styleIconRedCurr">
                    </watcher>
                </div>
            </div>
            <div class="chart__inf-wrapper">
                <div :class="fullStatus ? 'chart__inf-item__title chart__inf-item__title-full' :'chart__inf-item__title'">ПРОСАДКА</div>
                <div :class="fullStatus ? 'chart__inf-item__data chart__inf-item__data-full' : 'chart__inf-item__data'">
                    <watcher :data="dd" :units="'%'" :side="'left'"
                    :styleIconGreen = "styleIconGreenCurr"
                    :styleIconRed = "styleIconRedCurr">
                    </watcher>
                    </div>
            </div>-->
        </div>
        <div v-if="percentOfPositions" class="chart-info__right w-100">
            <div class="round-title">
                <descr :text="'% Успешных сделок'"
                :direction="'right'"></descr>
            </div>
            <round
                :currency="symbol">
            </round>
        </div>
		<div class="d-flex align-start">
			<menuYear :years="uniqueYear" v-if="periodMenu"
					  @changeYear = "setPeriod($event)"></menuYear>
		</div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import roundChart from '../ui-components/persent-of-close-positions'
import menuYear from './chartsForTabs/pofitInPercent/sig-menu-change-year-profit-chart'
import Description from "../ui-components/description"
import Watcher from "../ui-components/ui-data-watcher"
export default {
    data() {
        return {
            statistic:{},
            balance:null,
            equity:null,
            leverege:null,
            profit:null,
            profitPercent:null,
            profitPips:null,
            dd:null,
            uniqueYear:[],
            period:null,
            currencyProfit:null
        }
    },
    components: {
        "round":roundChart,
        "menuYear":menuYear,
        'descr':Description,
        'watcher':Watcher,
    },
    props: {
        symbol:{default:''},
        periodMenu:{default:true},
        fullStatus:{default:false},
        percentOfPositions:{default:true}
    },
    computed: {
        ...mapGetters({
              getStatistics: 'accountstat/getStatistics'
        })
    },
    methods: {
        getData() {
            let stat = this.getStatistics(this.symbol);
            if (!stat) {
                return;
            }
            this.statistics = stat;
            this.profit = this.statistics.Summary.ProfitAbs;
            this.profitPips = this.statistics.Summary.ProfitPoints;
            this.equity = this.statistics.DailyRecords[this.statistics.DailyRecords.length - 1].EquityClose;
            this.balance = this.statistics.DailyRecords[this.statistics.DailyRecords.length - 1].BalanceClose;
            if(this.statistics.DailyRecords[this.statistics.DailyRecords.length - 1].Leverage !== null) {
                this.leverege = (this.statistics.DailyRecords[this.statistics.DailyRecords.length - 1].Leverage).toFixed(1);
                this.currencyProfit = stat.DailyRecords[stat.DailyRecords.length - 1].EquityClose - stat.DailyRecords[stat.DailyRecords.length - 1].BalanceClose;
            }
            else {
                this.leverege = 0;
            }
            if(this.statistics.DailyRecords[this.statistics.DailyRecords.length - 1].Drawdown !== null) {
                this.dd = this.statistics.DailyRecords[this.statistics.DailyRecords.length - 1].Drawdown;
            } else {
                this.dd = 0
            }
            if(this.statistics.Summary.Equity !== null && this.statistics.DailyRecords[this.statistics.DailyRecords.length - 1].EquityOpen !== null) {
                this.profitPercent = (this.statistics.Summary.Equity - this.statistics.DailyRecords[this.statistics.DailyRecords.length - 1].EquityOpen) / this.statistics.Summary.Equity * 100;
            } else {
               this.profitPercent = 0;
            }
            let years = [];
            for(let i = 0; i < this.statistics.DailyRecords.length; i++) {
                let date = new Date(this.statistics.DailyRecords[i].Date).getUTCFullYear();
                years.push(date);
            }
            this.uniqueYear = [...new Set(years)];
        },
        setPeriod(year) {
            this.$emit('setYear', year);
        }
    },
    created() {
        subscribeOnUpdate(this.$store, this.symbol, isFirstObtained => {
            //if (!this.symbol || !this.symbol.length) {
                this.getData(this.symbol);
            //}
        });
        // может быть, данные уже есть в store
        this.getData(this.symbol);
    }
}
function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: symbol,
        callback: {
            id: `profit-sum-data-${symbol}`,
            handler: handler
        }
    });

}
</script>
<style lang="less" scoped>
.chart__inf {
    &-section {
        display: flex;
        align-items: baseline;
        &-right {
            margin-left: 12px;
            width: 100px;
        }
    }
    &-wrapper {
        display: flex;
        margin-bottom: 0;
    }
    &-item__title {
        font-family: Arimo;
        font-size: 12px;
        font-weight: 700;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.6;
        letter-spacing: .4px;
        color: #aabed2;
        text-transform: uppercase;
        margin-right: 12px;
        &-full {
            font-size: 23px;
            line-height: 1;
            margin-bottom: 12px;
        }

        @media (max-width:1680px) {
            font-size: 10px;
        }
        @media (max-width:1400px) {
            font-size: 8px;
        }
    }
    &-item__data {
        font-family: Arimo;
        //font-size: 13px;
        font-style: normal;
        font-weight: 700;
        font-stretch: normal;
        line-height: 1.27;
        letter-spacing: .4px;
        //max-height: 16px;
        color:#fff;
         &-full {
            font-size: 23px;
            line-height: 1;
            margin-bottom: 12px;
        }
        @media (max-width:1650px) {
            font-size: 12px;
        }
    }
}
.round-title {
    font-family: Arimo;
    font-size: 18px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1;
    letter-spacing: 0.4px;
    color: #aabed2;
    text-transform: uppercase;
    margin-right: 4px;
    margin-bottom: -18px;
}

</style>
